import styled, { css } from 'styled-components';
import { Icon } from '../icon/index.js';
import { getTypographyStyles, SYS_SIZE_FIXED_50, SYS_SPACE_FIXED_50, SEM_BORDER_WIDTH_NAVIGATION_DEFAULT, CMP_TYPOGRAPHY_NAVIGATION_TEXT_LINK_SM_LABEL_NORMAL, CMP_TYPOGRAPHY_NAVIGATION_TEXT_LINK_MD_LABEL_NORMAL, CMP_TYPOGRAPHY_NAVIGATION_TEXT_LINK_XS_LABEL_NORMAL, CMP_TYPOGRAPHY_NAVIGATION_TEXT_LINK_MD_LABEL_BOLD, CMP_TYPOGRAPHY_NAVIGATION_TEXT_LINK_SM_LABEL_BOLD, CMP_TYPOGRAPHY_NAVIGATION_TEXT_LINK_XS_LABEL_BOLD, getMargins, SYS_SPACE_FIXED_100 } from '@oneaudi/unified-web-common';
// TODO: Update values with spacing tokens from Design when available
// Values are currently manual calculations
const underlineOffsetSM = '6.5px';
const underlineOffsetMD = '7.1px';
export const StyledTextLink = styled.a `
  ${(props) => {
    if (props.variant === 'inline' && props.weight === 'bold') {
        return getTypographyStyles(props.size === 'md'
            ? CMP_TYPOGRAPHY_NAVIGATION_TEXT_LINK_MD_LABEL_BOLD
            : props.size === 'sm'
                ? CMP_TYPOGRAPHY_NAVIGATION_TEXT_LINK_SM_LABEL_BOLD
                : CMP_TYPOGRAPHY_NAVIGATION_TEXT_LINK_XS_LABEL_BOLD);
    }
    return getTypographyStyles(props.size === 'md'
        ? CMP_TYPOGRAPHY_NAVIGATION_TEXT_LINK_MD_LABEL_NORMAL
        : props.size === 'sm'
            ? CMP_TYPOGRAPHY_NAVIGATION_TEXT_LINK_SM_LABEL_NORMAL
            : CMP_TYPOGRAPHY_NAVIGATION_TEXT_LINK_XS_LABEL_NORMAL);
}};

  /* TODO: token */
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  transition-duration: 250ms;
  transition-property: color, text-decoration-color;
  margin: ${(props) => getMargins(props.margin)};
  display: ${(props) => props.variant === 'inline' ? 'inline-block' : 'inline-flex'};
  align-items: center;

  color: ${(props) => props.theme.cmp.color.navigation.textLink.foreground.default};

  text-decoration-line: underline;
  text-decoration-color: ${(props) => props.theme.cmp.color.navigation.textLink.foreground.default};

  :hover:not(:disabled),
  :active:not(:disabled) {
    color: ${(props) => props.theme.cmp.color.navigation.textLink.foreground.interactive};
    text-decoration-color: ${(props) => props.theme.cmp.color.navigation.textLink.foreground.interactive};
  }

  &:disabled {
    cursor: not-allowed;
    color: ${(props) => props.theme.cmp.color.navigation.textLink.foreground.disabled};
    text-decoration-color: ${(props) => props.theme.cmp.color.navigation.textLink.foreground.disabled};
  }

  ${(props) => props.variant === 'inline' &&
    css `
      text-decoration-thickness: ${props.weight === 'normal'
        ? SEM_BORDER_WIDTH_NAVIGATION_DEFAULT
        : SYS_SIZE_FIXED_50};
      text-decoration-skip-ink: none;
      ${StyledIcon} {
        vertical-align: ${props.size === 'md' ? 'bottom' : 'text-bottom'};
      }
    `}

  ${(props) => props.variant === 'standalone' &&
    css `
      text-decoration-thickness: ${SEM_BORDER_WIDTH_NAVIGATION_DEFAULT};
      text-underline-offset: ${props.size === 'md'
        ? underlineOffsetMD
        : underlineOffsetSM};
      padding-bottom: ${SYS_SIZE_FIXED_50};
    `}
    
  ${(props) => props.as === 'button' &&
    css `
      cursor: pointer;
      background: transparent;
      border: none;
      padding: 0;
      text-align: left;
      ${props.variant === 'standalone' &&
        css `
        padding-bottom: ${SYS_SIZE_FIXED_50};
      `}
    `}
`;
export const StyledIcon = styled(Icon) `
  flex-shrink: 0;
  ${(props) => props.variant === 'standalone' &&
    props.iconPosition === 'leading' &&
    css `
      margin-right: ${SYS_SPACE_FIXED_100};
    `}

  ${(props) => props.variant === 'standalone' &&
    props.iconPosition === 'trailing' &&
    css `
      margin-left: ${SYS_SPACE_FIXED_100};
    `}

  ${(props) => props.variant === 'inline' &&
    css `
      margin-left: ${SYS_SPACE_FIXED_50};
    `}
`;
//# sourceMappingURL=index.styles.js.map